// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MTdes","toggleWrap":"styles_toggleWrap__uG_ez","content":"styles_content__ZWHn0","selectAreaCode":"styles_selectAreaCode__1Jxhj"};